import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Swiper, {Parallax, Autoplay} from 'swiper';
import 'swiper/swiper-bundle.css';

import * as L from 'leaflet';
import * as L1 from 'leaflet.markercluster';

import gsap, {Power1} from 'gsap';
import isMobile from 'ismobilejs';

import JSShare from 'js-share';

const shareItems = document.querySelectorAll('.social_share');
for (let i = 0; i < shareItems.length; i += 1) {
    shareItems[i].addEventListener('click', function share(e) {
        return JSShare.go(this);
    });
}

const ismobile = isMobile().phone || window.innerWidth < 1024;

const randomInt = (min, max) => {
    if (max == null) {
        max = min;
        min = 0;
    }
    return Math.random() * (max - min) + Number(min);
};

let dragAnimation = null;

const initSlider = (slider) => {
    let previousIndex = 0;

    if (slider.dataset.perView && ismobile) {
        slider.dataset.perView = '';
        slider.dataset.space = '';
    }

    const s = new Swiper(slider, {
        modules: [Parallax, Autoplay],
        loop: slider.dataset.loop === 'true',
        autoplay: isMobile().phone ? {delay: 3000} : false,
        slidesPerView: slider.dataset.perView ? parseFloat(slider.dataset.perView) : 'auto',
        parallax: true,
        centeredSlides: slider.dataset.centered === 'true',
        autoHeight: slider.dataset.autoHeight === 'true',
        spaceBetween: slider.dataset.space ? parseFloat(slider.dataset.space) : 0,
        navigation: {
            nextEl: slider.dataset.navNext || null,
            prevEl: slider.dataset.navPrev || null,
        },
        pagination: slider.dataset.pagination ? {
            el: slider.dataset.pagination,
            type: 'fraction',
        } : false,
        mousewheel: slider.dataset.mousewheel === 'true' ? {
            releaseOnEdges: false,
        } : false,
    });

    s.on('slideChange', (e) => {

        if (!ismobile) {
            gsap.to(e.slides, .3, {
                opacity: 0,
            });

            gsap.to(e.visibleSlides, .3, {
                opacity: 1,
            });

        }

        previousIndex = e.realIndex;
    });

    if (slider.dataset.dragElement && (!isMobile().phone || window.outerWidth > 800)) {
        const dragEl = slider.querySelector(slider.dataset.dragElement);

        slider.addEventListener('mousemove', (e) => {
            cursorMove(dragEl, e.clientX, e.clientY);
        });

        slider.addEventListener('mouseenter', () => {
            gsap.to(dragEl, .3, {
                opacity: 1,
            });
        });

        ['mouseleave', 'mousewheel'].map(event =>
            slider.addEventListener(event, () => {
                if (event === 'mouseleave') {
                    hideCursor(dragEl);
                }
                else {
                    const buttonRect = dragEl.getBoundingClientRect();

                    if ((buttonRect.top > slider.getBoundingClientRect().bottom || buttonRect.bottom < slider.getBoundingClientRect().top) && event === 'mousewheel') {
                        hideCursor(dragEl);
                    }
                }
            }, {passive: true}),
        );

        s.on('touchMove', (e) => {
            cursorMove(dragEl, e.touches.currentX, e.touches.currentY - window.scrollY);
        });
    }
};

const cursorMove = (cursor, x, y) => {
    dragAnimation = gsap.to(cursor, .1, {
        display: 'flex',
        position: 'fixed',
        top: y - cursor.getBoundingClientRect().width / 2,
        left: x - cursor.getBoundingClientRect().width / 2,
        opacity: 1,
    });
};

const hideCursor = (dragEl) => {
    if (dragAnimation) {
        dragAnimation.kill();
    }

    gsap.to(dragEl, .3, {
        opacity: 0,
        onComplete: () => {
            gsap.set(dragEl, {
                clearProps: 'left,top,display,position',
                onComplete: () => {
                    gsap.to(dragEl, .3, {
                        opacity: 1,
                    });
                },
            });
        },
    });
};

window.addEventListener('DOMContentLoaded', () => {
    toggleFn();
    findDocumentsfn();
    initMap();
    variationChange();
    shareAnimation();

    if (!ismobile) {
        navHoverFn();
    }

    if (document.querySelector('.swiper, .swiper-mobile')) {
        const sliders = document.querySelectorAll('.swiper');

        Object.values(sliders).map(slider => {
            initSlider(slider);
        });

        if (ismobile) {
            const slidersMobile = document.querySelectorAll('.swiper-mobile');

            Object.values(slidersMobile).map(slider => {
                initSlider(slider);
            });

        }
    }

    const button = document.getElementById('printButton');

    if (button) {
        button.addEventListener('click', () => {
            window.print();
        });
    }

    const svgs = document.querySelectorAll('svg');

    Object.values(svgs).map(svg => SizeSVG(svg));

    const illuHome = document.querySelector('.home-title--illustration');

    if (illuHome) {
        const nextBounce = (path) => {
            gsap.to(path, randomInt(5, 10), {
                x: randomInt(-10, 10),
                y: randomInt(-10, 10),
                rotate: randomInt(-5, 10),
                ease: Power1.easeInOut,
                onComplete: function() {
                    nextBounce(path);
                },
            });
        };

        const paths = illuHome.querySelectorAll('path');

        Object.values(paths).map(item => {
            nextBounce(item);
        });

    }

    const multiCheckbox = document.querySelectorAll('.wc-memberships-member-profile-field');
    const formsWithDescription = document.querySelectorAll('.woocommerce-address-fields');

    if (multiCheckbox) {
        Object.values(multiCheckbox).map(box => {
            const tooltip = box.querySelector('span.description');

            if (tooltip) {
                const tooltipText = tooltip.innerText;
                tooltip.remove();

                const destination = box.closest('tr').querySelector('td:first-child');

                destination.innerHTML += `<p class="form-informations">${tooltipText}</p>`;
            }
        });
    }

    if (formsWithDescription) {
        Object.values(formsWithDescription).map(form => {
            const tooltip = form.querySelector('span.description');

            if (tooltip) {
                const tooltipText = tooltip.innerText;
                const destination = tooltip.closest('p');

                tooltip.remove();

                destination.innerHTML += `<p class="form-informations">${tooltipText}</p>`;
            }
        });
    }

    const search = document.querySelector('.section--search');
    const header = document.querySelector('.main-header');

    if (window.location.search && search) {
        window.scrollTo({
            top: search.getBoundingClientRect().top - header.getBoundingClientRect().height,
            left: 0,
            behavior: 'smooth',
        });
    }
});

let lastScrollTop = 0;
window.addEventListener('scroll', () => {

    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop) {
        // downscroll code
        window.scrollDirection = 'down';
    }
    else {
        // upscroll code
        window.scrollDirection = 'up';
    }

    const mainHeader = document.querySelector('.main-header');

    if (window.scrollY > 30) {
        mainHeader.classList.add('stuck');
    }
    else {
        mainHeader.classList.remove('stuck');
    }

    if (ismobile) {
        gsap.set(mainHeader, {
            y: window.scrollDirection === 'down' ? -(mainHeader.getBoundingClientRect().height)
                : (!document.body.classList.contains('hide--header') ? 0 : -(mainHeader.getBoundingClientRect().height)),
        });
    }

    lastScrollTop = st <= 0 ? 0 : st;
});

const toggleFn = () => {
    const buttons = document.querySelectorAll('[data-toggle]');

    for (const button of buttons) {
        if (button.classList.contains('button-play')) {
            button.closest('.media-video')?.addEventListener('click', () => {
                const id = button.dataset.toggle;
                const elementToToggle = document.querySelector(`[data-toggle-element=${id}]`);

                elementToToggle.classList.toggle('toggled');
            });
        }
        else {
            button.addEventListener('click', () => {
                const id = button.dataset.toggle;
                const elementToToggle = document.querySelector(`[data-toggle-element=${id}]`);

                Object.values(document.querySelectorAll(`[data-toggle=${id}]`)).map(item => item.classList.toggle('active'));
                elementToToggle.classList.toggle('toggled');

                if (elementToToggle.classList.contains('video--box')) {
                    const iframe = document.querySelector('.video--box iframe');
                    const iframeSrc = iframe.src;

                    iframe.setAttribute('src', iframeSrc);
                }
            });
        }
    }
};

const navHoverFn = () => {
    const hasChildren = document.querySelectorAll('.navigation .menu-item-has-children');
    const overlay = document.querySelector('.navigation--overlay');

    Object.values(hasChildren).map(item =>
        ['mouseenter', 'mouseleave'].map(event =>
            item.addEventListener(event, (e) => {
                const childNav = item.querySelector('.navigation--children');
                const rect = childNav.getBoundingClientRect();

                gsap.to(overlay, .5, {
                    height: event === 'mouseenter' ? rect.top + rect.height + 70 : 0,
                });

                gsap.to(childNav, .5, {
                    opacity: event === 'mouseenter' ? 1 : 0,
                    y: event === 'mouseenter' ? 0 : -40,
                    visibility: event === 'mouseenter' ? 'visible' : 'hidden',
                });

            }),
        ),
    );
};

let animShare = null;
const shareAnimation = () => {
    const shareBox = document.querySelector('.share--socials');

    if (shareBox) {
        const shareBackground = document.querySelector('.share--background');
        const shareList = shareBox.querySelector('ul');
        const shareWidth = shareList.getBoundingClientRect().width;

        ['mouseenter', 'touchstart'].map(event => {
            shareBox.addEventListener(event, () => {

                if (animShare) {
                    animShare.kill();
                }

                animShare = gsap.to(shareBackground, .1, {
                    opacity: 1,
                    top: -3,
                    bottom: -3,
                    left: -3,
                    right: -3,
                    onComplete: () => {
                        gsap.set(shareList, {
                            width: 0,
                            visibility: 'visible',
                            delay: .2,
                            onComplete: () => {
                                gsap.to(shareList, .2, {
                                    width: shareWidth,
                                });
                            },
                        });
                    },
                });
            });
        });

        shareBox.addEventListener('mouseleave', () => {
            if (animShare) {
                animShare.kill();
            }

            animShare = gsap.to(shareList, .2, {
                width: 0,
                onComplete: () => {
                    gsap.set(shareList, {
                        clearProps: 'all',
                    });

                    gsap.to(shareBackground, .1, {
                        opacity: 0,
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    });
                },
            });
        });
    }
};

const findDocumentsfn = () => {
    const form = document.querySelector('.form--document, .form--annuaire');

    if (form) {
        const inputs = document.querySelectorAll('.document--tags input[type=checkbox]');
        const hiddenIputs = form.querySelectorAll('input[hidden]');

        Object.values(inputs).map(input => {
            input.addEventListener('change', () => {
                const associatedInput = Object.values(hiddenIputs).find(e => e.id === `hidden_${input.dataset.cat}`);
                const valueArray = associatedInput.value !== '' ? associatedInput.value.split(',') : [];

                if (input.checked) {
                    valueArray.push(input.dataset.name);
                }
                else {
                    valueArray.splice(valueArray.findIndex(item => item === input.dataset.name), 1);
                }

                associatedInput.value = valueArray.join(',');
            });
        });
    }
};

const slugify = str =>
    str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');

const initMap = async () => {
    const mapEl = document.getElementById('map');
    if (mapEl) {

        const DefaultIcon = L.divIcon({
            html: `<svg class="no--resize" version="1.1" preserveAspectRatio="none" width="33" height="33" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 33 33">
                <path fill="#00505C" d="M16.49,25.48c-0.51-0.61-0.98-1.11-1.36-1.66c-1.47-2.14-2.99-4.26-4.34-6.47c-2.71-4.43,0.55-9.13,4.62-9.74c4.31-0.65,7.32,2.49,7.76,5.7c0.17,1.25-0.13,2.36-0.65,3.45c-1.3,2.76-3.12,5.17-5.01,7.53C17.21,24.65,16.88,25.02,16.49,25.48z M16.49,18.83c2.42,0,4.33-1.9,4.33-4.31c0-2.38-1.89-4.27-4.28-4.28c-2.41-0.02-4.36,1.89-4.39,4.27C12.12,16.87,14.09,18.83,16.49,18.83z"/>
                <path fill="#00505C" d="M13.52,14.51c0-1.65,1.33-2.98,2.98-2.98c1.63,0,2.99,1.35,3.01,2.99c0.02,1.63-1.41,3.05-3.04,3.03C14.84,17.52,13.51,16.15,13.52,14.51z"/>
            </svg>`,
            className: '',
            iconSize: [33, 33],
            iconAnchor: [16, 0],
        });

        L.Marker.prototype.options.icon = DefaultIcon;

        const clients = mapEl.getAttribute('data-clients');

        if (!clients) {
            const map = L.map('map').setView([parseFloat(mapEl.dataset.lat), parseFloat(mapEl.dataset.lon)], 16);
            L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            }).addTo(map);

            const clientObject = {
                name: mapEl.dataset.name,
                company: mapEl.dataset.company,
                address: mapEl.dataset.address,
                displayName: '',
                longlat: {
                    lat: mapEl.dataset.lat, lon: mapEl.dataset.lon,
                },
            };
            const markers = new L1.MarkerClusterGroup({}).addTo(map);

            if (clientObject.longlat.lat && clientObject.longlat.lon) {
                showMarker(L, map, clientObject, '', '', markers);
            }
        }
        else {
            const map = L.map('map').setView([48.8534, 2.3488], 7);
            L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
            }).addTo(map);

            const markers = new L1.MarkerClusterGroup({}).addTo(map);

            JSON.parse(clients).map(client => {
                const name = `${client.meta.billing_last_name} ${client.meta.billing_first_name}`;

                const clientObject = {
                    name: name !== ' ' ? name : client.display_name,
                    company: client.meta.billing_company,
                    address: `${client.meta.billing_address_1} - ${client.meta.billing_postcode} ${client.meta.billing_city}`,
                    displayName: client.display_name,
                    longlat: {lat: client.meta.latitude, lon: client.meta.longitude},
                };

                if (clientObject.longlat.lat && clientObject.longlat.lon) {
                    showMarker(L,
                        map, clientObject,
                        slugify(clientObject.name), client.id, markers);
                }

                if (client.meta.billing2_street) {
                    const clientObjectBis = {
                        name: name !== ' ' ? name : client.display_name,
                        company: client.meta.billing2_company,
                        address: `${client.meta.billing2_street} - ${client.meta.billing2_postcode} ${client.meta.billing2_city}`,
                        displayName: client.display_name,
                        longlat: {
                            lat: client.meta.latitude, lon: client.meta.longitude,
                        },
                    };

                    if (clientObjectBis.longlat.lat && clientObjectBis.longlat.lon) {
                        showMarker(L,
                            map, clientObjectBis,
                            slugify(clientObjectBis.name), client.id, markers);
                    }
                }
            });
        }
    }
};

const showMarker = async (L, map, client, slug, id, markers) => {
    L.marker([parseFloat(client.longlat.lat), parseFloat(client.longlat.lon)]).addTo(markers).bindPopup(`
            <strong>${client.name}</strong><br/><br/>
            ${client.company ? `${client.company}<br/>` : ''}
            ${client.address}<br/><br/>
            ${slug ? `<a class="button--link bg-quintery" href="/therapeute/?nom=${slug}&id=${id}"><span>Voir la fiche</span></a>` : ''}`,
    );
};

const updateQueryStringParameter = (uri, key, value) => {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
    }
    else {
        return uri + separator + key + '=' + value;
    }
};

const variationChange = () => {
    const variationForm = document.querySelector('#formules');
    if (variationForm) {
        const descriptionEl = document.querySelector('.product--description-text');
        const imageEl = document.querySelectorAll('.product--photo figure.product--illustration img');
        const sourceEl = document.querySelectorAll('.product--photo figure.product--illustration source');

        variationForm.addEventListener('change', (e) => {
            const data = JSON.parse(e.target.closest('form').dataset.product_variations);
            const variation = data.find(item => item.attributes.attribute_formules === e.target.value);

            console.log(variation, imageEl, sourceEl);

            descriptionEl.innerHTML = variation.variation_description;

            window.history.pushState(variation.attributes.attribute_formules, variation.attributes.attribute_formules, updateQueryStringParameter(window.location.href, 'attribute_formules', variation.attributes.attribute_formules));

            const related = document.querySelectorAll('.product--other li');
            const relatedToHide = document.querySelector(`.product--other li[data-formules="${variation.attributes.attribute_formules}"]`);

            Object.values(related).map(item => {
                item.removeAttribute('hidden');
            });

            Object.values(imageEl).map(item => item.src = variation.image.full_src);
            Object.values(sourceEl).map(item => item.srcset = variation.image.full_src);

            relatedToHide.setAttribute('hidden', true);
        });
    }
};

const SizeSVG = (element) => {
    if (element) {
        const svgWidth = parseFloat(element.getAttribute('width')?.replace('px', ''));

        if ((!isMobile().phone || window.outerWidth > 800) && !element.classList.contains('no--resize')) {
            gsap.set(element, {
                width: (svgWidth * 100) / 1440 + 'vw',
                height: 'auto'
            })
        }
    }
};
